import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * A mecânica de empilhar, animar e sumir sozinho vem do `sonner` — é exatamente
 * o "caro e chato de acertar à mão" que os primitivos existem para trazer
 * pronto. A aparência não: `Toast.tsx` (a marca) desenha o próprio conteúdo
 * com `toast.custom(...)`, então nada aqui decide cor — nem tema.
 *
 * A CLI gerava isto lendo `next-themes` (projeto Next.js) e trocando os ícones
 * padrão por `lucide-react`. Os dois saíram: não há `next-themes` nesta stack,
 * e os ícones do `sonner` nunca aparecem — o conteúdo é sempre o nosso, via
 * `toast.custom`. Duas famílias de ícone na mesma tela é o problema que
 * `primitives/icons.tsx` existe para evitar, e a saída mais simples é não
 * precisar de nenhum ícone daqui.
 */
function Toaster({ ...props }: ToasterProps) {
  return <Sonner className="toaster group" {...props} />;
}

export { Toaster };
